export const sideTabTitle = [
  {
    title: "Chega de perder tempo redefinindo senhas",
  },
  {
    title: "Esqueça a complexidade de gerenciar múltiplas senhas",
  },
  {
    title: "Chega de perder tempo redefinindo senhas",
  },
  {
    title: "Acabe com invasões e acessos não autorizados",
  },
];

export const sideTabCard = [
  {
    image: "/assets/card-image-1.png",
    overlayTitle:
      "De 20% a 50% dos tickets no Help Desk são sobre redefinição de senhas",
    overlaySubtitle: "(Security Boulevard)",
    title: "Chega de perder tempo redefinindo senhas",
    description:
      "Nossa autenticação biométrica com prova de vida elimina a necessidade constante de redefinir senhas, diminuindo o desgaste das equipes, economizando o tempo valioso do seu suporte técnico.",
  },
  {
    image: "/assets/card-image-2.png",
    overlayTitle:
      "Um executivo precisa gerenciar, em média, 190 senhas diferentes.",
    overlaySubtitle: "(Security Magazine)",
    title: "Esqueça a complexidade de gerenciar múltiplas senhas",
    description:
      "Simplifique a gestão de acessos com um único método confiável e inteligente. Livre-se definitivamente da necessidade de memorizar múltiplas senhas, garantindo praticidade e produtividade em qualquer ambiente de trabalho.",
  },
  {
    image: "/assets/card-image-3.png",
    overlayTitle:
      "Um executivo precisa gerenciar, em média, 190 senhas diferentes.",
    overlaySubtitle: "(Security Magazine)",
    title: "Reduza gastos com gestão insegura de credenciais",
    description:
      "Reduza imediatamente gastos ao automatizar a autenticação. Primatio Vault elimina custos desnecessários com credenciais, liberando recursos para investir no que realmente importa.",
  },
  {
    image: "/assets/card-image-4.png",
    overlayTitle:
      "Mais de 80% das brechas vêm de ataques de força bruta e credenciais roubadas.",
    overlaySubtitle: "(Verizon DBIR)",
    title: "Acabe com invasões e acessos não autorizados",
    description:
      "Proteja-se definitivamente contra ataques comuns e invasões maliciosas. Nossa solução baseada em IA com prova de vida impede o acesso não autorizado, garantindo que apenas usuários reais e validados acessem seus sistemas críticos.",
  },
];
